import { apiClient } from '@/core/api';
import type {
  ChannelRow,
  Cockpit,
  CockpitRange,
  DashboardSummary,
  Forecast,
  SearchHit,
} from './types';

export async function getDashboard(): Promise<DashboardSummary> {
  const { data } = await apiClient.get<DashboardSummary>('/command-center/dashboard/');
  return data;
}

export async function getCockpit(range: CockpitRange): Promise<Cockpit> {
  const { data } = await apiClient.get<Cockpit>('/command-center/cockpit/', {
    params: { range },
  });
  return data;
}

export async function getChannels(): Promise<ChannelRow[]> {
  const { data } = await apiClient.get<ChannelRow[]>('/command-center/channels/');
  return data;
}

/** Finance-role only (403 otherwise). */
export async function getForecast(): Promise<Forecast> {
  const { data } = await apiClient.get<Forecast>('/command-center/forecast/');
  return data;
}

/** Cross-module global search (org-scoped, staff-only). */
export async function globalSearch(q: string): Promise<SearchHit[]> {
  const { data } = await apiClient.get<SearchHit[]>('/command-center/search/', { params: { q } });
  return data;
}
